export default __webpack_public_path__ + "static/media/followers.c34716d1.svg";